import request from 'utils/http.js'

/** 门户 - 查询banner图列表 */
export function bannerApi(params) {
	return request({
		url: '/news/banner/portal/list',
		method: 'get',
		params
	})
}
/** 门户 - 查询banner图详情 */
export function bannerDataApi(id) {
	return request({
		url: '/news/banner/portal/' + id,
		method: 'get',
	})
}

/** 门户 - 查询合作企业管理列表 */
export function enterpriseApi(params) {
	return request({
		url: '/news/cooEnt/portal/list',
		method: 'get',
		params
	})
}

/** 门户 - 查询新闻中心列表 */
export function newsApi(params) {
	return request({
		url: '/news/centreInfo/portal/list',
		method: 'get',
		params
	})
}
/** 门户 - 查询新闻中心详情 */
export function newsDataApi(id) {
	return request({
		url: '/news/centreInfo/portal/' + id,
		method: 'get',
	})
}

/** 门户 - 查询产品列表 */
export function productListApi(params) {
	return request({
		// url: '/erp/product/portal/list/r',
		url:'/erp/product/portal/fontPageList/r',
		method: 'get',
		params
	})
}
// 关于我们
export function aboutApi() {
	return request({
		url: '/system/notice/getAboutUs',
		method: 'get',
	})
}

// 解决方案列表
export function schemeListApi(params) {
	return request({
		url: '/erp/schemeInfo/portal/treeErpSchemeInfoVo',
		method: 'get',
		params
	})
}
// 解决方案详情
export function schemeDataApi(id) {
	return request({
		url: '/erp/schemeInfo/portal/' + id,
		method: 'get',
	})
}

// —————————————————————————————————————————————— 新的接口 ——————————————————————
// 解决方案列表
export function fanganListApi(params, isLocale) {
	return request({
		url: '/erp/schemeInfo/portal/list',
		method: 'get',
		headers: {
			'content-language': isLocale
		},
		params
	})
}
// 推荐分类
export function fenleiListApi(params) {
	return request({
		url: '/erp/category/portal/list',
		method: 'get',
		params
	})
}
// —————————————————————————————————————————————— 新产品接口 ——————————————————————
/** 新增产品 */
export function productAddApi(data) {
	return request({
		url: '/erp/product/portal/add/batch',
		method: 'post',
		data: data
	})
}
/** 修改产品 */
export function productEditApi(data) {
	return request({
		url: '/erp/product/portal/edit/batch',
		method: 'post',
		data: data
	})
}
/** 根据主键id查询产品各语言数据 */
export function productDataApi(id) {
	return request({
		url: '/erp/product/portal/query/edit/' + id,
		method: 'get',
	})
}
/** 产品新增修改机翻 */
export function productJfApi(data) {
	return request({
		url: '/erp/product/portal/translate',
		method: 'post',
		data: data
	})
}

// —————————————————————————————————————————————————— 新逻辑
export function addApi(data) {
	return request({
		url: '/erp/product/portal/add',
		method: 'post',
		data: data
	})
}
export function getApi(id) {
	return request({
		url: '/erp/product/portal/query/edit/' + id,
		method: 'get',
	})
}
export function editApi(data) {
	return request({
		url: '/erp/product/portal/edit',
		method: 'post',
		data: data
	})
}
export function editLangApi(data) {
	return request({
		url: '/erp/productI18n/portal/add/or/edit',
		method: 'post',
		data: data
	})
}
export function fanyiApi(data) {
	return request({
		url: '/erp/product/portal/translate',
		method: 'post',
		data: data
	})
}

export function textsList() {
	return request({
		url: '/platform/info/portal/list',
		method: 'get',
	})
}
export function textsDetail(name) {
	return request({
		url: '/platform/info/portal/title?title=' + name,
		method: 'get',
	})
}
// —————————————————— 预约模块 ————————————————
/** 新增IDEF 2025展会预约登记 */
export function addAppointmentRecord(data) {
	return request({
		url: '/system/meetingRegistration',
		method: 'post',
		data: data
	})
}

/** 获取智能助手流式回答 */
// {
//     "sessionId": "string",// 生成随机id + 日期 例：uuid-2025-08-16
//     "text": "string",// 用户输入文本
//     "botId": "string"
// }
export function getSmartStream(data) {
	return request({
		url: '/erp/smart/stream',
		method: 'post',
		data: data
	})
}
